<template>
  <div class="wrapper">
    <div class="container">
      <h3>授权</h3>
      <h4>恭喜您，设置成功！<br/> 请您扫描如下二维码进行授权：</h4>
      <img :src="qrCodeUrl" class="qrcode" />
      <div class="refresh-btn" @click="wxGetweChatKey">
        <img src="../assets/images/refresh.png" class="icon-refresh" />刷新
      </div>
      <!-- <img src="../assets/images/ic-auth-succes.png" class="qrcode" /> -->
      <p>授权成功后, 请您及时在奇点群告诉我们。<br/>我们将为您完成接下来的注册操作。 </p>
      <div class="footer-bar"></div>
      <div class="footer">
        <router-link :to="{path: '/register-base?shopCode='+shopCode}" class="jump-btn">跳过</router-link>
        <!-- <router-link :to="{path: '/set-industry?shopCode='+shopCode}" class="jump-btn">跳过</router-link> -->
      </div>
    </div>
  </div>
</template>
<script>
import { wxGetweChatKey} from '@/api/register';
export default {
  name: 'storeList',
  data() {
    return {
      isFiled: 0,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      shopCode: null,
      qrCodeUrl: ''
    }
  },
  created() {
    this.wxGetweChatKey();
    if(this.$route.query){
      this.shopCode = this.$route.query.shopCode;
    }
    if(this.$route.query.isFiled){
      this.isFiled = this.$route.query.isFiled;
    }
  },
  methods: {
    wxGetweChatKey() {
      wxGetweChatKey().then(res => {
        this.qrCodeUrl = res.data;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.container{
  height: 100%;
  padding-top: 1px;
  h3{
    width: 100%;
    line-height: 1.4;
    font-size: 24px;
    color: #222;
    font-weight: bold;
    text-align: center;
    margin: 100px auto 10px;
  }
  h4{
    font-size: 16px;
    color: #222;
    text-align: center;
    margin-top: 12px;
  }
  .qrcode{
    width: 200px;
    height: 200px;
    display: block;
    margin: 15px auto;
  }
  .refresh-btn{
    margin: 0 auto;
    font-size: 14px;
    color: #47B6C7;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    cursor: pointer;
    .icon-refresh{
      width: 20px;
      margin-right: 4px;
    }
  }
  p{
    line-height: 1.4;
    font-size: 16px;
    color: #666;
    text-align: center;
  }
}
.jump-btn{
  line-height: 1.4;
  font-size: 16px;
  color: #47B6C7;
  text-align: center;
  display: block;
  margin-left: 12px;
}
@media screen and (max-width:750px){
  .container{
    width: 94%;
    margin: 0 3%;
  }
}
@media screen and (min-width:750px){
  
}
</style>


// WEBPACK FOOTER //
// src/views/auth-succes.vue